import { c as _c } from "react/compiler-runtime";
import { getErrorMessage } from '@onefootprint/fetch-hosted';
import type { ApiError } from '@onefootprint/request-types';
import { useToast } from '@onefootprint/ui';
type FieldError = {
  key: string;
  message: string;
};
const useRequestErrorToast = () => {
  const $ = _c(2);
  const {
    toast
  } = useToast();
  let t0;
  if ($[0] !== toast) {
    t0 = (error, fieldErrors) => {
      const description = Array.isArray(fieldErrors) && fieldErrors[0]?.message ? (fieldErrors as FieldError[]).map(_temp).join(", ") : getErrorMessage(error);
      toast({
        description,
        title: "Uh-oh!",
        variant: "error"
      });
    };
    $[0] = toast;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const notify = t0;
  return notify;
};
export type { FieldError };
export default useRequestErrorToast;
function _temp(e) {
  return e?.message;
}